{
    "AUTH_TOKEN_INVALID": "Phiên đăng nhập không hợp lệ. Vui lòng đăng nhập lại.",
    "AUTH_TOKEN_EXPIRED": "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
    "AUTH_TOKEN_REUSE_DETECTED": "Phát hiện sử dụng lại token đã thu hồi. Tất cả phiên đã bị đăng xuất vì lý do bảo mật.",
    "AUTH_PERM_VERSION_STALE": "Quyền truy cập đã được cập nhật. Đang làm mới phiên...",
    "AUTH_PERMISSION_DENIED": "Bạn không có quyền thực hiện hành động này.",
    "AUTH_CSRF_MISSING": "Thiếu mã bảo vệ CSRF. Vui lòng tải lại trang.",
    "AUTH_CSRF_MISMATCH": "Mã bảo vệ CSRF không khớp. Vui lòng tải lại trang.",
    "AUTH_RATE_LIMIT_EXCEEDED": "Quá nhiều yêu cầu. Vui lòng thử lại sau.",
    "AUTH_RECAPTCHA_FAILED": "Xác minh reCAPTCHA thất bại. Vui lòng thử lại.",
    "AUTH_RECAPTCHA_TOKEN_MISSING": "Thiếu token reCAPTCHA. Vui lòng thử lại.",
    "AUTH_OTP_INVALID": "Mã OTP không hợp lệ hoặc đã hết hạn.",
    "AUTH_OTP_RESEND_TOO_FAST": "Yêu cầu gửi lại mã OTP quá nhanh. Vui lòng đợi rồi thử lại.",
    "AUTH_PASSWORD_REUSED": "Không thể sử dụng lại 5 mật khẩu gần nhất.",
    "AUTH_ACCOUNT_LOCKED": "Tài khoản đã bị khóa do quá nhiều lần đăng nhập sai.",
    "AUTH_LAST_SUPERADMIN": "Không thể thực hiện — đây là superadmin cuối cùng còn hoạt động.",
    "AUTH_SETUP_TOKEN_INVALID": "Token thiết lập không hợp lệ hoặc đã hết hạn.",
    "AUTH_PORTAL_ACCESS_DENIED": "Tài khoản của bạn không có quyền truy cập cổng này.",
    "AUTH_WS_ORIGIN_REJECTED": "Origin của WebSocket không được chấp nhận.",
    "AUTH_WS_TICKET_INVALID": "Ticket WebSocket không hợp lệ hoặc đã được sử dụng.",
    "AUTH_OAUTH_STATE_INVALID": "Tham số state của OAuth không hợp lệ. Vui lòng thử đăng nhập lại.",
    "AUTH_IMPERSONATE_DENYLIST_ACTION": "Hành động này bị chặn khi đang giả lập (impersonating) người dùng khác.",
    "AUTH_FORCE_RELOGIN": "Quyền truy cập của bạn đã thay đổi. Vui lòng đăng nhập lại.",
    "VENDOR_REAPPLY_COOLDOWN": "Vui lòng đợi hết thời gian chờ trước khi gửi lại đơn đăng ký nhà cung cấp."
}
